<template>
    <!-- eslint-disable-next-line vuejs-accessibility/no-static-element-interactions vuejs-accessibility/click-events-have-key-events -->
    <div ref="imageEl" class="h-full" @click="onImageElClick($event)">
        <MiscLink
            v-if="content.data?.media != null && content?.config?.url?.value != null && content.config.url.value.trim() !== ''"
            :to="content.config.url.value"
            :target="linkTarget"
            :aria-label="ariaLabel"
            v-bind="$attrs"
        >
            <MiscImage
                class="w-full"
                :class="[
                    {
                        'object-cover': content?.config?.displayMode?.value === 'cover'
                    },
                    imageMinHeight
                ]"
                :src="content.data.media.url"
                :alt="imageAlt"
                :media-width="content.data.media.metaData?.width"
                :media-height="content.data.media.metaData?.height"
                :lazy-load="!isHeroElement"
                :preload="isHeroElement ? { fetchPriority: 'high' } : false"
                :fetchpriority="isHeroElement ? 'high' : 'auto'"
                :img-min-height="imageMinHeight"
                :style="imageStyles"
            />
        </MiscLink>
        <MiscImage
            v-else-if="content.data?.media != null"
            class="w-full h-full"
            :class="[
                { 'object-cover': content?.config?.displayMode?.value === 'cover' },
                imageMinHeight
            ]"
            :src="content.data.media.url"
            :alt="imageAlt"
            :aria-label="ariaLabel"
            :media-width="content.data.media.metaData?.width"
            :media-height="content.data.media.metaData?.height"
            :lazy-load="!isHeroElement"
            :preload="isHeroElement ? { fetchPriority: 'high' } : false"
            :fetchpriority="isHeroElement ? 'high' : 'auto'"
            :img-min-height="imageMinHeight"
            :style="imageStyles"
            v-bind="$attrs"
        />
    </div>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = defineProps<{
    content: Schemas['CmsElementImage']
}>()

const isHeroElement = computed(() => {
    return props.content?.config?.isHeroElement?.value
})

const isDecorative = computed(() => !!props.content?.config?.isDecorative?.value)
const ariaLabel = computed(() => (isDecorative.value ? undefined : props.content?.config?.ariaLabel?.value || undefined))
const imageAlt = computed(() => (isDecorative.value ? '' : props.content?.data?.media?.alt))
const linkTarget = computed(() => (props.content?.config?.newTab?.value ? '_blank' : undefined))

const lcpHeroClaimed = useState<boolean>('a4g-lcp-hero-claimed', () => false)
if (isHeroElement.value && props.content?.data?.media != null) lcpHeroClaimed.value = true

const imageMinHeight = computed(() => {
    if (props.content?.config?.displayMode?.value === 'cover') {
        return  `min-h-[${props.content?.config?.minHeight?.value}]`
    } else {
        return 'min-h-none'
    }
})

const imageStyles = computed(() => {
    const styles: string[] = []
    
    // Add aspect ratio for layout shift prevention
    const aspectRatio = props.content?.config?.aspectRatio?.value
    if (aspectRatio && aspectRatio !== 'auto') {
        styles.push(`aspect-ratio: ${aspectRatio}`)
    }
    
    return styles.length > 0 ? styles.join('; ') : undefined
})

const imageEl = ref<HTMLDivElement | null>(null)
const trackingData: PromotionData | undefined = props.content?.config?.promotion?.value
const { selectPromotion, computedPromotionData } = usePromotionObserver(
    imageEl,
    trackingData
)

function onImageElClick (event: MouseEvent) {
    if (computedPromotionData?.value) selectPromotion(computedPromotionData.value, event)
}
</script>
